import axios from "axios"
import api from '../api'

export const state = {
  settings: {
    dateService: {
      serieFactura: '',
      oblioSecretKey: '',
      oblio_email: '',
    },
    tarife: {},
    language: '',
  }
}

export const mutations = {
  UPDATE_SETTING (state, { key, value }) {
    state.settings[key] = value;
  },
  SET_RAR_FLAGS (state, value) {
    state.settings = {
      ...state.settings,
      rar_email: value,
      rar_password: value
    };
  },
  RESET_RAR_FLAGS (state) {
    state.settings = {
      ...state.settings,
      rar_email: false,
      rar_password: false
    };
  }
}

export const actions = {
  async get_settings ({state, commit}) {
    try {
      const { data: setari } = await axios('/api/get-setari');
      localStorage.setItem('language', setari.language);
      commit('SET_KEY_VALUE', { key: 'settings', sub: 'setari', value: setari });
    } catch (e) {
      state.error = 'Eroare primire comenzi din server.'
    }
  },
  async save_settings ({ state, commit }) {
    await axios.post('/api/save-settings', state.settings);
    commit('SET_KEY_VALUE', { key: 'lang', value: state.settings.language });
  },
  async save_rar_settings({ commit }, payload) {
    try {
      const response = await axios.post(api.setari_rar, payload);

      if (response.data && response.data.ok) {
        commit('SET_RAR_FLAGS', true);
      }

      return response.data;

    } catch (error) {
      throw new Error(
        error.response?.data?.message ||
        'Email sau parolă incorectă.'
      );
    }
  },
  async logout_rar ({ state, commit }) {
    try {
      await axios.delete('/api/setari/rar');
      commit('RESET_RAR_FLAGS');
    } catch (e) {
      state.error = 'Eroare logout RAR.'
    }
  }
}
